/**
 * 批量上传关键词
 */
import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-batch-upload-keyword',
  imports: [SharedModule, BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
      (nzOnOk)="nzOnOk()"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadKeywordComponent {
  // 输入属性
  readonly isVisible = input<boolean>(false);

  // 输出事件
  readonly isVisibleChange = output<boolean>();

  // 上传配置
  uploadConfig: BatchUploadConfig = {
    title: '批量上传关键词',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量上传关键词模板_2025-12-25.xlsx',
    type: 6,
    description: '1、下载批量上传关键词模板，批量填写关键词信息',
  };

  nzOnOk() {
    // 手动埋点 红品智-工具-批量上传关键词
    (window as any)?.lwTrackEvent?.add({
      event_id: 253,
      event_code: 'spotlight-tools-uploadCreateKeyword',
      event_type: 'upload',
    });
  }
}
